module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-10 col-xs-10 col-xs-offset-1"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "id": "search",
      "placeholder": "Search for internships, positions and just about anything"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.greet($event)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('md-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("SEARCH")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row col-md-4 col-xs-3  col-md-offset-5 col-sm-offset-5 col-xs-offset-4",
    staticStyle: {
      "display": "none",
      "float": "left"
    },
    attrs: {
      "id": "preloader"
    }
  }, [_c('div', {
    staticClass: "col-md-offset-1"
  }, [_c('circle8', {
    attrs: {
      "size": "100px"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.results), function(index) {
    return _c('div', {
      staticClass: "search-result col-lg-4 col-md-6 col-xs-12"
    }, [_c('md-card', {
      staticClass: "md-primary",
      staticStyle: {},
      attrs: {
        "flex": "",
        "md-with-hover": "",
        "md-elevation": "15"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(index.organisation))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                Commitment: " + _vm._s(index.commitment) + " "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                City: " + _vm._s(index.city) + " "), _c('br')])]), _vm._v(" "), _c('md-card-expand', {
      staticClass: "margT"
    }), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
      staticClass: "theme",
      attrs: {
        "href": index.form,
        "target": "_blank"
      }
    }, [_vm._v("Apply")]), _vm._v(" "), _c('md-button', {
      staticClass: "theme",
      attrs: {
        "md-expand-trigger": ""
      }
    }, [_vm._v("\n                  More Info\n                ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    })], 1), _vm._v(" "), _c('md-card-content', [_vm._v("\n                  " + _vm._s(index.description) + "\n              ")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini md-clean md-fab-bottom-right",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hideBtn"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be25538","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 898
// module chunks = 1